import React from 'react';
import { TbMail, TbPhone } from 'react-icons/tb';
import '../styles/components/Footer.scss';

import Logo from '../assets/logos/en_stock_logo.svg';
import ContactPhones from './ContactPhones';
import PaymentMarquee from './PaymentMarquee';

const Footer = () => {
  return (
    <footer className="Footer">
      <div className="Footer__main">
        <div className="Footer__brand">
          <img className="Footer__logo" src={Logo} alt="Logo promocionales en-stock" />
          <p className="Footer__about">
            Productos promocionales personalizados con tu logo: bolígrafos, vasos,
            tecnología y mucho más, con marcación profesional.
          </p>
        </div>

        <div className="Footer__col">
          <h3 className="Footer__title">Contáctenos</h3>
          <a className="Footer__line" href="mailto:ventas@en-stock.com">
            <TbMail className="Footer__icon" aria-hidden="true" />
            ventas@en-stock.com
          </a>
          <div className="Footer__line Footer__line--phones">
            <TbPhone className="Footer__icon" aria-hidden="true" />
            <ContactPhones className="Footer__phones" />
          </div>
        </div>

        <div className="Footer__col Footer__col--payments">
          <h3 className="Footer__title">Paga fácil y seguro</h3>
          <PaymentMarquee />
        </div>
      </div>

      <div className="Footer__bottom">
        © {new Date().getFullYear()} Promocionalesenstock™. Derechos reservados.
      </div>
    </footer>
  );
};

export default Footer;
